import React from 'react';
import DevicePage from './DevicePage';

const SensorPage: React.FC = () => {
  return <DevicePage deviceType="sensor" />;
};

export default SensorPage;
